const indexInit = {
    
}
const address = (state = indexInit, action) => {
    switch (action.type) {
      case "ADDRESS_LST":
        return Object.assign({}, state, {
          ...action
        });
      case "AREA_LST":
        return Object.assign({}, state, {
          ...action
        });
      default:
        return state;
    }
}

export default address